import { Input } from './input';
import { Label } from './label';
import { PhoneWithOperator } from './phone-with-operator';
import { cn } from '@/lib/utils';

interface PhoneInputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  showOperator?: boolean;
  className?: string;
  required?: boolean;
  id?: string;
}

/**
 * Input de telefone com formatação e consulta automática de operadora
 */
export function PhoneInput({
  label,
  value,
  onChange,
  placeholder = '(00) 00000-0000',
  showOperator = true,
  className,
  required = false,
  id,
}: PhoneInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;
    
    // Remover tudo que não é número
    let digits = inputValue.replace(/\D/g, '');
    
    // Limitar a 11 dígitos (DDD + 9 dígitos)
    if (digits.length > 11) {
      digits = digits.substring(0, 11);
    }
    
    // Aplicar máscara
    let formatted = digits;
    if (digits.length > 2) {
      formatted = `(${digits.substring(0, 2)}) ${digits.substring(2)}`;
    }
    if (digits.length > 7) {
      formatted = `(${digits.substring(0, 2)}) ${digits.substring(2, 7)}-${digits.substring(7)}`;
    }
    
    onChange(formatted);
  };

  return (
    <div className={cn('space-y-2', className)}>
      {label && (
        <Label htmlFor={id}>
          {label}
          {required && <span className="text-destructive ml-1">*</span>}
        </Label>
      )}
      
      <div className="flex items-center gap-2">
        <Input
          id={id}
          type="tel"
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          className="flex-1"
        />
        
        {showOperator && value && value.length > 10 && (
          <PhoneWithOperator phone={value} variant="badge-only" />
        )}
      </div>
    </div>
  );
}
